import { render, staticRenderFns } from "./PDFSellerRelateTable.vue?vue&type=template&id=47564d24"
import script from "./PDFSellerRelateTable.vue?vue&type=script&lang=js"
export * from "./PDFSellerRelateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports